import {CompanyMemberRole} from "./companyMember";

export enum NotificationType {
    ANNOUNCEMENT = "ANNOUNCEMENT",
    INVITATION = "INVITATION",
    FIELD_RESULTS = "FIELD_RESULTS",
}

export enum NotificationStatus {
    SENT = "SENT",
    SCHEDULED = "SCHEDULED",
    DRAFT = "DRAFT",
    CANCELLED = "CANCELLED",
}

export interface Notification {
    id?: string;
    type: NotificationType;
    name: string;
    startTime: string | null;
    status: NotificationStatus;
    targetAll?: boolean | null;
    targetUsers?: string[] | null;
    targetCompanies?: string[] | null;
    targetRoles?: CompanyMemberRole[] | null;
    metaData?: Record<string, unknown>;
    createdBy?: string;
    seen?: string[] | boolean;
    expirationDate?: Date | null;
    createdAt?: Date;
    updatedAt?: Date;
}
